// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MRs4","comment":"styles_comment__2cDTC"};